import {
  Button,
  Grid,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Paper,
  Tooltip,
  ArrowBackIosNewOutlined as ArrowBackIosNewOutlinedIcon,
  Close as CloseIcon,
  Check,
} from "../../../common/utils/mui-imports";
import { format } from "date-fns";
import {
  ArrowRight2,
  Bag,
  MoreSquare,
  Refresh,
  SearchNormal1,
} from "iconsax-react";
import { MRT_ColumnDef } from "material-react-table";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  EnumInspectionStatus,
  EnumPageMode,
  EnumPageType,
  EnumSortTypes,
} from "../../../common/enums/common.enums";
import { CheckFunctionRights } from "../../../common/functions/common.functions";
import {
  SortDropDownDTO,
  StatusStatisticsDTO,
} from "../../../common/types/common.dto.types";
import HPRCheckBox from "../../../components/common/HPRCheckBox/HPRCheckBox";
import HPRMaterialReactTable from "../../../components/common/HPRMaterialReactTable/HPRMaterialReactTable";
import InspectionAssignmentOverviewStatus from "../../../components/common/InspectionAssignmentOverviewComponents/InspectionAssignmentOverviewStatus";
import { EnumPopupType } from "../../../components/Popups/Popup.enum";
import { openPopup } from "../../../components/Popups/Popup.reducer";
import { PopupProps } from "../../../components/Popups/PopupProps.types";
import { useAppDispatch, useAppSelector } from "../../../core/hooks";
import {
  EnumSystemFunctions,
  EnumSystemFunctionTypes,
} from "../../../core/reducers/functionRights.types";
import { PageRegistrationProperties } from "../../../core/reducers/pageRegistrationReducer.types";
import { InspectionSetPageParametersType } from "../InspectionSetPage/InspectionSetPage.types";
import {
  deleteInspectonsByTemplateId,
  getInspectonsByTemplateId,
} from "./ViewInspectionPage.action";
import {
  Inspection,
  StatusCount,
  ViewInspectionPageState,
} from "./ViewInspectionPage.type";
import {
  resetViewInspectionInitState,
  setDeletedSuuccessfully,
} from "./ViewInspectionPage.reducer";

const ViewInspectionPage = (props: PageRegistrationProperties) => {
  const initialState = {
    Data: [] as Array<Inspection>,
    PageSize: 10,
    TotalRecordsCount: 0,
    StatusCounts: [] as Array<StatusCount>,
  } as ViewInspectionPageState;

  const dispatch = useAppDispatch();
  const location = useLocation();
  const dataFetchedRef = useRef(false);

  const pageProps = location.state;

  const inspections = useAppSelector(
    (state: any) => state.viewInspectionPageReducer?.Data || []
  );

  // reducer
  const viewInspectionSetsState = useAppSelector(
    (state) => state.viewInspectionPageReducer
  );

  //page state
  const [viewInspectionSetPageState, setViewInspectionSetPageState] =
    useState(initialState);

  const [inspectionId, setInspectionId] = useState(0);
  const [inspectionName, setInspectionName] = useState("");
  const [templateId, setTemplateId] = useState(pageProps.TemplateId || 0);
  const [InspectionStatus, setInspectionStatus] = useState(0);
  const [showRemove, setShowRemoveStatus] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(-1);
  const [pageDataSize, setPageDataSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [isChecked, setIsChecked] = useState(false); //check button showing
  const [searchText, setSearchText] = useState("");
  const [refreshRotate, setRefreshRotate] = useState(false);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [isSchedulePreparedVisible, setIsSchedulePreparedVisible] =
    useState(false);
  const [hasShownSchedulePreparedOnce, setHasShownSchedulePreparedOnce] =
    useState(false);

  const authState = useAppSelector((state) => state.authReducer);
  const [initialSortState, setInitialSortState] = useState<SortDropDownDTO>({
    Label: "InspectionName",
    Value: "2",
    SortType: EnumSortTypes.Ascending,
  });
  const [sortState, setSortState] = useState<SortDropDownDTO>({
    Label: "InspectionName",
    Value: "2",
    SortType: EnumSortTypes.Ascending,
  });

  //-----Page load styles-----
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = headerH?.current?.offsetHeight || 0;
      const statusHeight = statusH?.current?.offsetHeight || 0;

      let tableHeight =
        window.innerHeight - (headerHeight + statusHeight) - 150;

      setTableHeight(tableHeight);
    };

    // Calculate initial height
    calculateHeight();

    // Resize handler
    function handleResize() {
      calculateHeight();
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //-----Page load Data-----
  useEffect(() => {
    setIsDataFetched(false);
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    dispatch(
      getInspectonsByTemplateId({
        TemplateId: pageProps.TemplateId,
        SelectedPage: pageNumber,
        ListPageSize: pageDataSize,
        SearchText: "",
        StatusFilter: EnumInspectionStatus.Scheduled,
        Sort: initialSortState,
        ShowCompleted: false,
      })
    );
  }, []);

  // This runs when the component unmounts
  useEffect(() => {
    return () => {
      dispatch(resetViewInspectionInitState());
    };
  }, [dispatch]);

  // call the getting API if deleted successfully template
  useEffect(() => {
    if (!viewInspectionSetsState.deletedSuccessfully) return;
    dispatch(
      getInspectonsByTemplateId({
        TemplateId: pageProps.TemplateId,
        SelectedPage: pageNumber,
        ListPageSize: pageDataSize,
        SearchText: "",
        StatusFilter: selectedStatus,
        Sort: sortState,
        ShowCompleted: isChecked,
      })
    );
  }, [viewInspectionSetsState.deletedSuccessfully]);

  //set Page State when reducer change
  useEffect(() => {
    setRefreshRotate(false);
    setViewInspectionSetPageState(viewInspectionSetsState);

    if (viewInspectionSetsState?.StatusCounts?.length) {
      setIsDataFetched(true);
      dispatch(setDeletedSuuccessfully(false));

      // Show message only once
      if (!hasShownSchedulePreparedOnce) {
        setIsSchedulePreparedVisible(true);
        setHasShownSchedulePreparedOnce(true);
      }
    }
  }, [viewInspectionSetsState]);

  useEffect(() => {
    if (isSchedulePreparedVisible) {
      const timer = setTimeout(() => {
        setIsSchedulePreparedVisible(false);
      }, 6000);

      return () => clearTimeout(timer);
    }
  }, [isSchedulePreparedVisible]);

  const onRemoveInspection = () => {
    dispatch(
      openPopup({
        Open: true,
        BodyText: `Are you sure you want to delete ${inspectionName} ?`,
        HeaderText: "Confirmation",
        PopupType: EnumPopupType.YesNoConfirmation,
        NoButtonText: "Cancel",
        OkButtonText: "Confirm",
        Size: "modal-md",
        YesBtnClick() {
          handleDeleteInspections(inspectionId);
          handleMenuClose();
        },
      } as PopupProps)
    );
  };

  //function to check function rights
  const checkSystemFunctionRight = (
    functionId: EnumSystemFunctions,
    functionTypeId: EnumSystemFunctionTypes
  ): boolean => {
    return CheckFunctionRights(
      authState.FunctionRights,
      EnumPageType.InspectionSets,
      functionId,
      functionTypeId
    );
  };

  const columns: Array<MRT_ColumnDef<any>> = [
    {
      id: "Location-1",
      accessorKey: "Locations",
      header: "Locations",
    },
    {
      id: "InspectionName-2",
      accessorKey: "InspectionName",
      header: "Inspection Name",
      size: 270,
    },
    {
      id: "Status-3",
      accessorKey: "Status",
      header: "Status",
      size: 120,
      Cell: ({ cell }) => {
        const value = cell.getValue();

        const getStatusClass = (status: string) => {
          switch (status?.toLowerCase()) {
            case "completed":
              return "status-50";
            case "in progress":
              return "status-30";
            case "scheduled":
              return "status-20";
            case "overdue":
              return "status-60";
            case "exception":
              return "status-90";
            case "pending":
              return "status-0";
            case "cancelled":
              return "status-0";
            default:
              return "status-0";
          }
        };

        const statusClass = getStatusClass(String(value));

        return (
          <div className="d-flex" style={{ alignItems: "center" }}>
            <div className="standards-status" style={{ height: "15px" }}>
              <span
                className={`status-pill mr-10 status-section status-pill-size ${statusClass}`}
              ></span>
            </div>
            {String(value)}
          </div>
        );
      },
    },
    {
      id: "Progress-4",
      accessorKey: "Progress",
      header: "Progress",
      size: 40,
    },
    {
      id: "ScheduledDate-5",
      accessorKey: "ScheduledDate",
      header: "Scheduled Date And Time",
      size: 150,
    },
    {
      id: "ScheduledBy-6",
      accessorKey: "ScheduledBy",
      header: "Scheduled By",
      size: 160,
    },
    {
      id: "PlannedCompletionDate-7",
      accessorKey: "PlannedCompletionDate",
      header: "Planned Completion Date",
      size: 160,
    },
    {
      id: "More-8",
      accessorKey: "More",
      header: "",
      enableSorting: false,
      size: 50,
      Cell: ({ row }) =>
        row.original.StatusId != 7 ? (
          <Tooltip title={"Show more"}>
            <IconButton
              id="more-btn"
              onClick={(event) =>
                handleMenuClick(
                  event,
                  row.original.InspectionId,
                  row.original.StatusId,
                  row.original.ShowRemove,
                  row.original.InspectionName
                )
              }
            >
              <MoreSquare
                size="22"
                color="#219ebc"
                style={{ transform: "rotate(90deg)" }}
              />
            </IconButton>
          </Tooltip>
        ) : null,
    },
  ];

  //----------------------------Inspection Detail Menu---------------------------------
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (
    event: React.MouseEvent<HTMLElement>,
    rowId: number,
    status: number,
    showRemove: boolean,
    inspectionName: string
  ) => {
    setInspectionStatus(status);
    setInspectionId(rowId);
    setShowRemoveStatus(showRemove);
    setInspectionName(inspectionName);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  // ---------------------------------menu end--------------------------------------
  const navigate = useNavigate();

  const onMoreDetailsClick = () => {
    navigate("/assignInspection", {
      state: {
        InspectionId: inspectionId,
        TemplateId: pageProps.TemplateId,
        PageMode:
          InspectionStatus == 50
            ? EnumPageMode.ViewMode
            : EnumPageMode.EditMode,
        TemplateName: pageProps.TemplateName,
        AssessmentType: pageProps.AssessmentType || "",
      },
    });
  };

  const TableCellComponent = (props: {
    value: any;
    showToolTip?: boolean;
    className?: string;
  }) => {
    return props.showToolTip ? (
      <Tooltip title={!props.value || props.value === "-" ? "" : props.value}>
        <span className={`${props.className}`}>{props.value}</span>
      </Tooltip>
    ) : (
      <span className={props.className}>{props.value}</span>
    );
  };

  //-----standard list heigh ------
  const headerH = useRef(null);
  const statusH = useRef(null);

  //Set Hight
  const [tableHeight, setTableHeight] = useState(0);

  useEffect(() => {}, [inspections]);

  const [statusStatistics, setStatusStatistics] = useState<
    StatusStatisticsDTO[]
  >([]);

  useEffect(() => {
    const formattedStatuses = (viewInspectionSetPageState.StatusCounts || [])
      .filter((item) => item.Status !== EnumInspectionStatus.Preparing)
      .map((item) => ({
        Id: item.Status,
        StatusName: item.StatusName,
        Count: item.Count,
        DisplayOrder: item.DisplayOrder,
      }));

    setStatusStatistics(formattedStatuses);
  }, [viewInspectionSetPageState.StatusCounts]);

  // Check if selectedStatus Sheduled exists in statusStatistics, if not set to All
  useEffect(() => {
    const statusArray = viewInspectionSetsState.StatusCounts;
    if (selectedStatus === -1 && statusArray.length > 0) {
      const isScheduled = statusArray.some(
        (i) => i.Status == EnumInspectionStatus.Scheduled
      );
      if (!isScheduled) {
        setSelectedStatus(EnumInspectionStatus.All);
      } else {
        setSelectedStatus(EnumInspectionStatus.Scheduled);
      }
    }
  }, [viewInspectionSetsState]);

  // StatusId to Status string mapping
  const statusMap: Record<number, string> = {
    0: "All",
    7: "Preparing",
    10: "Not Planned",
    20: "Scheduled",
    30: "In Progress",
    40: "Paused",
    50: "Completed",
    60: "Overdue",
    70: "Rejected",
    80: "Removed",
    90: "Exception",
    100: "Deactivated",
  };

  // Map the fetched data to the grid format
  const gridData =
    viewInspectionSetPageState?.Data?.map((item: any) => ({
      Locations: item.SiteName,
      InspectionName: item.InspectionName,
      Status: statusMap[item.StatusId] || "",
      Progress: item.StatusId === 7 ? "N/A" : item.Progress,
      ScheduledDate: format(
        new Date(item.ScheduledDate),
        "dd-MMM-yyyy HH:mm:ss"
      ),
      ScheduledBy: item.ScheduledBy,
      PlannedCompletionDate:
        item.PlannedCompletionDate == null
          ? "N/A"
          : format(new Date(item.PlannedCompletionDate), "dd-MMM-yyyy"),
      InspectionId: item.InspectionId,
      StatusId: item.StatusId,
      ShowRemove: item.ShowRemoveButton,
    })) || [];

  const currentPage = pageNumber;
  const totalRecords =
    Number(viewInspectionSetPageState.TotalRecordsCount) || 0;

  const BacktnOnclick = () => {
    navigate("/inspectionSet", {
      state: {
        InspectionSetId: templateId,
      } as InspectionSetPageParametersType,
    });
  };

  const handleDeleteInspections = (id: number) => {
    dispatch(
      deleteInspectonsByTemplateId({
        InspectionId: id,
      })
    );
  };

  // Unified search trigger function
  const handleSearch = () => {
    dispatch(
      getInspectonsByTemplateId({
        TemplateId: templateId,
        SelectedPage: 1,
        ListPageSize: 10,
        SearchText: searchText,
        StatusFilter: EnumInspectionStatus.All,
        Sort: sortState,
        ShowCompleted: isChecked,
      })
    );
    setSelectedStatus(0);
    setIsChecked(false);
  };

  // Trigger on Enter key
  const onSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleClearSearch = () => {
    const clearedText = "";
    setSearchText(clearedText);

    dispatch(
      getInspectonsByTemplateId({
        TemplateId: templateId,
        SelectedPage: 1,
        ListPageSize: 10,
        SearchText: clearedText, // <-- Use the cleared value directly
        StatusFilter: EnumInspectionStatus.Scheduled,
        Sort: sortState,
        ShowCompleted: isChecked,
      })
    );

    setSelectedStatus(-1);
    setIsChecked(false);
  };

  const handleChangeInput = (value: string) => {
    setSearchText(value);
    if (value === "") {
      handleClearSearch();
    }
  };

  // Handle pagination change
  // This function is called when the user changes the page or page size
  const handlePaginationChange = (selectedPage: number, pageSize: number) => {
    setPageDataSize(pageSize);
    setPageNumber(selectedPage);
    dispatch(
      getInspectonsByTemplateId({
        TemplateId: templateId,
        SelectedPage: selectedPage,
        ListPageSize: pageSize,
        SearchText: searchText,
        StatusFilter: selectedStatus,
        Sort: sortState,
        ShowCompleted: isChecked,
      })
    );
  };

  // Handle checkbox change to filter inspections
  // This function is called when the user change checkBox
  const handleCheckBoxChange = (name: string, checked: boolean) => {
    setIsChecked(checked);
    setSelectedStatus(EnumInspectionStatus.Scheduled);
    dispatch(
      getInspectonsByTemplateId({
        TemplateId: templateId,
        SelectedPage: 1,
        ListPageSize: pageDataSize,
        SearchText: searchText,
        StatusFilter: EnumInspectionStatus.Scheduled,
        Sort: sortState,
        ShowCompleted: checked,
      })
    );
  };

  // Handle status click to filter inspections
  // This function is called when the user clicks on a status filters
  const onStatusClick = (statusId: number) => {
    setSelectedStatus(statusId);
    dispatch(
      getInspectonsByTemplateId({
        TemplateId: templateId,
        SelectedPage: 1,
        ListPageSize: pageDataSize,
        SearchText: searchText,
        StatusFilter: statusId,
        Sort: sortState,
        ShowCompleted: isChecked,
      })
    );
  };

  const handleStatusRefresh = () => {
    setRefreshRotate(true);
    dispatch(
      getInspectonsByTemplateId({
        TemplateId: templateId,
        SelectedPage: 1,
        ListPageSize: 10,
        SearchText: "",
        StatusFilter: EnumInspectionStatus.All,
        Sort: sortState,
        ShowCompleted: isChecked,
      })
    );
    setSelectedStatus(0);
    setIsChecked(false);
  };

  const getPercentage = (
    currentNumerator: number,
    currentDenominator: number
  ): number => {
    const total = currentNumerator + currentDenominator;
    if (total === 0) return 100;
    const processed = total - currentNumerator;
    return parseFloat(((processed / total) * 100).toFixed(1));
  };

  const handleSort = (sortBy: SortDropDownDTO) => {
    setSortState(sortBy);
    dispatch(
      getInspectonsByTemplateId({
        TemplateId: templateId,
        SelectedPage: 1,
        ListPageSize: pageDataSize,
        SearchText: searchText,
        StatusFilter: selectedStatus,
        Sort: {
          Label: sortBy.Label,
          Value: sortBy.Value,
          SortType: sortBy.SortType,
        },
        ShowCompleted: isChecked,
      })
    );
  };

  return (
    <>
      <div className="content-section-card top-main-padding view-inspection">
        {/* Global Sub Header with  Buttons*/}
        <div ref={headerH}>
          <Grid
            container
            columns={12}
            className="global-subhead-btn-wrap top-main-border-inner new-wrapping-requirement flex--container mb-0"
          >
            <div className="global-subhead-wrap mr-auto no-wrap flex__item">
              <div className="flex__item--inherit pr-10">
                <h2>
                  <Button
                    aria-label="back"
                    className="sub-head-back-btn back"
                    onClick={BacktnOnclick}
                    title="Back to home page"
                  >
                    {/* <ArrowLeft2 size="24" variant="Outline" /> */}
                    <ArrowBackIosNewOutlinedIcon className="" />
                    <span className="body-bold secondary-color">Back</span>
                  </Button>
                </h2>
              </div>
              <div
                className="mb-5 d-flex no-wrap"
                style={{ width: "-webkit-fill-available" }}
              >
                <h1 className="tab-view-fnt-resize no-wrap">
                  {props.PageTitle}
                </h1>
                <span className="d-flex pl-10 pr-10 fx-align-center arrow-separator">
                  <ArrowRight2 size="20" color="#023047" />
                </span>
                <Tooltip title={pageProps.TemplateName}>
                  <h1 className="tab-view-fnt-resize no-wrap limit-1">
                    {pageProps.TemplateName}
                  </h1>
                </Tooltip>
                <div className="standards-status ml-10 fx-middle">
                  <span className="status-color all">
                    {pageProps.AssessmentType ?? ""}
                  </span>
                </div>
              </div>
            </div>
            <div className="justify-middle" style={{ width: "inherit" }}>
              <div className="search-bar--small" style={{ minWidth: "350px" }}>
                <Paper
                  component="form"
                  sx={{
                    p: "2px 4px",
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                  onSubmit={(e) => {
                    e.preventDefault(); // prevent form default
                    handleSearch();
                  }}
                >
                  <InputBase
                    value={searchText}
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search by Inspection name / Location"
                    inputProps={{ "aria-label": "TaskName" }}
                    onChange={(e) => handleChangeInput(e.target.value)}
                    onKeyDown={onSearchKeyDown}
                  />

                  {/* on hover close icon  */}
                  {/* Show CloseIcon only when there is text */}
                  {searchText && (
                    <Tooltip title="Clear" placement="top">
                      <IconButton className="mr-0" onClick={handleClearSearch}>
                        <CloseIcon
                          style={{ color: "#219ebc", fontSize: "20px" }}
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip title="Search">
                    <IconButton
                      type="submit" // triggers form submit
                      sx={{ p: "10px" }}
                      aria-label="search"
                      className="m-0"
                    >
                      <SearchNormal1
                        variant="Outline"
                        className="ico-secondary"
                        size={18}
                      />
                    </IconButton>
                  </Tooltip>
                </Paper>
              </div>
            </div>
            {/* Global Sub Header with  Buttons*/}
          </Grid>
        </div>

        <Grid
          container
          className="checkbox-filter-wrap pt-5 pb-5 ml-10 valign-middle"
          ref={statusH}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={7}
            lg={8}
            style={{ marginLeft: "-14px" }}
          >
            {/* Status */}
            <InspectionAssignmentOverviewStatus
              statusStatistics={statusStatistics}
              selectedStatus={selectedStatus}
              onStatusClick={onStatusClick}
              statusFilterRef={statusH}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={5} lg={4}>
            <div className="checkbox-filter d-flex align-right">
              <div className="d-flex">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 16px",
                  }}
                >
                  {isDataFetched &&
                    (viewInspectionSetPageState.StatusCounts.some(
                      (item) =>
                        item.Status === EnumInspectionStatus.Preparing &&
                        item.Count > 0
                    ) ||
                      gridData?.length > 0) &&
                    (() => {
                      const statusItem =
                        viewInspectionSetPageState.StatusCounts.find(
                          (item) =>
                            item.Status === EnumInspectionStatus.Preparing
                        );

                      if (statusItem && statusItem.Count > 0) {
                        return (
                          <>
                            {/* Left side - Status text with loader */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              <div className="mr-5 no-wrap">
                                Preparing schedules:{" "}
                                <span
                                  className="semi-bold primary-blue-text"
                                  style={{ color: "#0277bd" }}
                                >
                                  {getPercentage(
                                    statusItem.Count,
                                    totalRecords + statusItem.Count
                                  )}
                                  %
                                </span>
                              </div>
                            </div>

                            {/* Refresh Button */}
                            <div className="refresh-btn-wrapper">
                              <Tooltip
                                title="Click to update records"
                                placement="top"
                              >
                                <Button
                                  className="rem-lined-btn refresh-btn"
                                  variant="outlined"
                                  startIcon={
                                    <Refresh
                                      className={
                                        refreshRotate ? "rotate-icon" : ""
                                      }
                                      style={{ height: "15px", width: "15px" }}
                                    />
                                  }
                                  onClick={handleStatusRefresh}
                                  disabled={statusItem.Count === 0}
                                >
                                  Refresh
                                </Button>
                              </Tooltip>
                            </div>
                          </>
                        );
                      }

                      return (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            opacity: isSchedulePreparedVisible ? 1 : 0,
                            transition: "opacity 1s ease-in-out",
                          }}
                        >
                          <Check color="success" fontSize="small" />
                          <div className="mr-5 no-wrap">Schedule Prepared</div>
                        </div>
                      );
                    })()}
                </div>
                <div className="checkbox-filter d-flex align-right no-wrap">
                  <HPRCheckBox
                    Id={"ShowCompletedInspection"}
                    Name={"ShowCompletedInspection"}
                    Label={"Show Completed Inspection(s)"}
                    ClassName={"inline-single-element font-14"}
                    checked={isChecked}
                    onCheckBoxChange={handleCheckBoxChange}
                  ></HPRCheckBox>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>

        <div
          style={{ maxHeight: tableHeight, width: "100%" }}
          className="view-inspection-table"
        >
          <Grid container>
            <Grid
              item
              xs={12}
              className="grid-height pl-10 pr-10 hpr-material-table width100-p"
            >
              <HPRMaterialReactTable
                MaxHeight={tableHeight}
                Columns={columns}
                Data={gridData}
                PaginationProps={{
                  TotalRecordsCount:
                    selectedStatus != EnumInspectionStatus.All
                      ? statusStatistics.find((i) => i.Id === selectedStatus)
                          ?.Count
                      : viewInspectionSetPageState?.TotalRecordsCount,
                  SelectedPage: currentPage,
                  PageSize: pageDataSize,
                  onPaginationChangeCallBack: handlePaginationChange,
                }}
                InitialSortByState={initialSortState}
                DefaultSort={initialSortState}
                CallbackFunctionProps={{ onChangeSortByCallBack: handleSort }}
                EnableSorting={viewInspectionSetPageState.StatusCounts.some(
                  (item) =>
                    item.Status === EnumInspectionStatus.Preparing &&
                    item.Count === 0
                )}
              />
            </Grid>
          </Grid>
        </div>
      </div>
      {/* more detailed dialog start*/}
      <div className="more-dialog">
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          className="sort-dialog-content"
          id="basic-menu"
        >
          <MenuItem
            onClick={() => {
              onMoreDetailsClick();
            }}
          >
            <div className="flex--container width100-p">
              <div className="flex__item">Detailed view</div>
              <div className="flex__item--inherit text-right">
                <ArrowRight2 variant="Outline" className="ico-primary" />
              </div>
            </div>
          </MenuItem>
          {checkSystemFunctionRight(
            EnumSystemFunctions.InspectionSetandAssignmentPage_Delete_Inspection,
            EnumSystemFunctionTypes.ButtonAccess
          ) && showRemove ? (
            <MenuItem
              onClick={() => {
                onRemoveInspection();
              }}
            >
              <div className="flex--container width100-p">
                <div className="flex__item">Remove</div>
                <div className="flex__item--inherit text-right">
                  <Bag
                    variant="Outline"
                    className="ico-primary"
                    size="20"
                    color="#ef5350"
                  />
                </div>
              </div>
            </MenuItem>
          ) : null}
        </Menu>
      </div>
    </>
  );
};

export default ViewInspectionPage;
